module.exports = __webpack_public_path__ + "img/thoda.df0bc404.jpg";